import { render, staticRenderFns } from "./ScreenTypeSearch.vue?vue&type=template&id=2d32d813&scoped=true"
import script from "./ScreenTypeSearch.vue?vue&type=script&lang=js"
export * from "./ScreenTypeSearch.vue?vue&type=script&lang=js"
import style0 from "./ScreenTypeSearch.vue?vue&type=style&index=0&id=2d32d813&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d32d813",
  null
  
)

export default component.exports